import { Divider, GridItem, Text } from "@chakra-ui/react";
import * as React from "react";
import { SubLeverGridItem } from "./index";

function LeverGridItem({ lever, leverIndex, register, control, submitSwitchChange }) {
  return (
    <>
      <GridItem colSpan={19}>
        <Text fontSize="md">{`${leverIndex + 1}. ${lever.name}`}</Text>
      </GridItem>
      <GridItem colSpan={19}>
        <Divider />
      </GridItem>
      {lever.subLevers && lever.subLevers.map((subLever, subLeverIndex) => {
        return <SubLeverGridItem
          key={`sub-lever-${subLever.id}`}
          lever={lever}
          subLever={subLever}
          subLeverIndex={subLeverIndex}
          register={register}
          control={control}
          submitSwitchChange={submitSwitchChange}
        />;
      })}
    </>
  );
}

export default LeverGridItem;